import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";

export class RevisoApi{
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor(){
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }
    
    async getAccountsFromThirdsGroupsInReviso(args: object): Promise<any> {
        try{
            const res = await this.query_dispatcher.dispatch('get.accounts.from.thirds.groups.in.reviso', args);
            return res
        }catch(error){
            console.log(error)
            return []
        }
    }
}